import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-connect-doctors-id-register-send',
  templateUrl: './connect-doctors-id-register-send.component.html',
  styleUrls: ['./connect-doctors-id-register-send.component.css'],
})
export class ConnectDoctorsIdRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  constructor(title: Title) {
    super();
    title.setTitle('認証メール送信完了');
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }
  ngOnInit(): void {}
}
